(function () {
  'use strict';

  function initMobileMenu() {
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    var iconMenu = document.querySelector('[data-icon-menu]');
    var iconClose = document.querySelector('[data-icon-close]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      var isOpen = menu.classList.toggle('is-open');
      if (iconMenu) iconMenu.classList.toggle('dgtl-hidden', isOpen);
      if (iconClose) iconClose.classList.toggle('dgtl-hidden', !isOpen);
    });
  }

  function initTimestamp() {
    var el = document.querySelector('[data-live-timestamp]');
    if (!el) return;
    function update() {
      el.textContent = new Date().toISOString().replace('T', ' ').substring(0, 19) + ' UTC';
    }
    update();
    setInterval(update, 1000);
  }

  function initProductGallery() {
    var main = document.querySelector('[data-main-image]');
    if (!main) return;
    document.querySelectorAll('[data-thumb-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-thumb-src');
        if (src) main.src = src;
        document.querySelectorAll('.dgtl-product-gallery__thumb').forEach(function (t) {
          t.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      });
    });
  }

  function initQuantity() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var input = form.querySelector('[data-qty-input]');
    var display = form.querySelector('[data-qty-display]');
    var minus = form.querySelector('[data-qty-minus]');
    var plus = form.querySelector('[data-qty-plus]');
    if (!input) return;

    function setQty(n) {
      var val = Math.max(1, n);
      input.value = val;
      if (display) display.textContent = val;
    }
    if (minus) minus.addEventListener('click', function () { setQty(parseInt(input.value, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(parseInt(input.value, 10) + 1); });
  }

  function initVariants() {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;

    var product = JSON.parse(jsonEl.textContent);
    var variantInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-product-price]');
    var addBtn = section.querySelector('[data-add-to-cart]');
    var selected = {};

    section.querySelectorAll('[data-option-name]').forEach(function (btn) {
      if (btn.classList.contains('is-selected')) {
        selected[btn.getAttribute('data-option-name')] = btn.getAttribute('data-option-value');
      }
      btn.addEventListener('click', function () {
        var name = btn.getAttribute('data-option-name');
        var value = btn.getAttribute('data-option-value');
        selected[name] = value;
        section.querySelectorAll('[data-option-name="' + name + '"]').forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
        });
        updateVariant();
      });
    });

    function updateVariant() {
      var variant = product.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selected[product.options[i]] === opt;
        });
      });
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) {
        var html = '<span class="dgtl-product-info__price">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<span class="dgtl-product-info__compare">' + formatMoney(variant.compare_at_price) + '</span>';
        }
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'ADD TO BAG' : 'OUT OF STOCK';
      }
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
    }
  }

  function initOverlayTime() {
    var el = document.querySelector('[data-overlay-time]');
    if (!el) return;
    function update() {
      el.textContent = new Date().toISOString().replace('T', ' ').substring(0, 19) + ' UTC';
    }
    update();
    setInterval(update, 1000);
  }

  function getYouTubeId(url) {
    var patterns = [
      /youtu\.be\/([^?&#]+)/,
      /youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/)([^?&#]+)/,
      /[?&]v=([^?&#]+)/
    ];
    for (var i = 0; i < patterns.length; i++) {
      var match = url.match(patterns[i]);
      if (match) return match[1];
    }
    return null;
  }

  function getVimeoId(url) {
    var match = url.match(/(?:vimeo\.com\/(?:video\/)?|player\.vimeo\.com\/video\/)(\d+)/);
    return match ? match[1] : null;
  }

  function embedVideoUrl(url) {
    if (!url || !url.trim()) {
      return '<p style="color:#fff;text-align:center;padding:2rem;font-family:monospace;font-size:0.875rem;">No video linked yet.<br><br>Add a YouTube, Vimeo, or MP4 link in Theme editor → Video gallery → Video item.</p>';
    }

    url = url.trim();

    if (url.indexOf('youtube.com') !== -1 || url.indexOf('youtu.be') !== -1) {
      var ytId = getYouTubeId(url);
      if (ytId) {
        return '<iframe src="https://www.youtube.com/embed/' + ytId + '?autoplay=1&mute=1&rel=0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen title="Video"></iframe>';
      }
    }

    if (url.indexOf('vimeo.com') !== -1 || url.indexOf('player.vimeo.com') !== -1) {
      var vimeoId = getVimeoId(url);
      if (vimeoId) {
        return '<iframe src="https://player.vimeo.com/video/' + vimeoId + '?autoplay=1&muted=1" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Video"></iframe>';
      }
    }

    if (/\.(mp4|webm|mov)(\?|$)/i.test(url) || url.indexOf('cdn.shopify.com') !== -1) {
      return '<video src="' + url + '" class="dgtl-relic-video" controls autoplay playsinline data-relic-video></video>';
    }

    return '<p style="color:#fff;text-align:center;padding:2rem;font-family:monospace;font-size:0.875rem;">Could not play this link.<br><br>Use a YouTube, Vimeo, or direct .mp4 URL.</p>';
  }

  function exitDocumentFullscreen() {
    var doc = document;
    var el = doc.fullscreenElement || doc.webkitFullscreenElement || doc.msFullscreenElement;
    if (!el) return;
    var fn = doc.exitFullscreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
    if (fn) fn.call(doc);
  }

  /* Plays inline in the lightbox. Falls back to muted if the browser blocks sound. */
  function startRelicPlayback(player) {
    if (!player) return;
    var video = player.querySelector('[data-relic-video]');
    if (!video) return;
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        video.muted = true;
        var retry = video.play();
        if (retry && typeof retry.catch === 'function') retry.catch(function () {});
      });
    }
  }

  /* Masthead gem cycles the page palette: default -> blue -> red -> yellow. */
  function initRelicTheme() {
    var gem = document.querySelector('[data-rlc-theme]');
    if (!gem) return;
    var shell = gem.closest('.rlc');
    if (!shell) return;

    var THEMES = ['default', 'blue', 'red', 'yellow'];
    var LABELS = { default: 'Default', blue: 'Blue', red: 'Red', yellow: 'Yellow' };
    var STORE_KEY = 'dgtl-relic-palette';

    function stored() {
      try {
        var saved = window.localStorage.getItem(STORE_KEY);
        return THEMES.indexOf(saved) !== -1 ? saved : 'default';
      } catch (err) {
        return 'default';
      }
    }

    function apply(name) {
      THEMES.forEach(function (t) {
        if (t === 'default') return;
        shell.classList.remove('rlc--' + t);
        document.body.classList.remove('rlc-bg--' + t);
      });
      if (name !== 'default') {
        shell.classList.add('rlc--' + name);
        document.body.classList.add('rlc-bg--' + name);
      }
      var next = THEMES[(THEMES.indexOf(name) + 1) % THEMES.length];
      gem.setAttribute('title', 'Page color: ' + LABELS[name] + ' (click for ' + LABELS[next] + ')');
      gem.setAttribute('aria-label', 'Page color ' + LABELS[name] + '. Switch to ' + LABELS[next] + '.');
    }

    var current = stored();
    apply(current);

    gem.addEventListener('click', function () {
      current = THEMES[(THEMES.indexOf(current) + 1) % THEMES.length];
      try {
        window.localStorage.setItem(STORE_KEY, current);
      } catch (err) { /* private mode — selection just won't persist */ }
      apply(current);
    });
  }

  function initVideoGallery() {
    var gallery = document.querySelector('[data-video-gallery]');
    if (!gallery) return;

    var filter = gallery.querySelector('[data-video-filter]');
    var filterBtns = gallery.querySelectorAll('[data-video-filter-btn]');
    var currentCat = 'all';
    var search = gallery.querySelector('[data-video-search]');
    var empty = gallery.querySelector('[data-video-empty]');
    var count = gallery.querySelector('[data-video-count]');
    var nowPlaying = gallery.querySelector('[data-now-playing]');
    var lightbox = gallery.querySelector('[data-video-lightbox]');
    var player = gallery.querySelector('[data-lightbox-player]');

    function applyFilter() {
      var cat = filterBtns.length ? currentCat : (filter ? filter.value : 'all');
      var query = search ? search.value.trim().toLowerCase() : '';
      var visible = 0;

      gallery.querySelectorAll('[data-video-card]').forEach(function (card) {
        var matchCat = cat === 'all' || card.getAttribute('data-category') === cat;
        var title = card.getAttribute('data-title') || '';
        var matchSearch = !query || title.indexOf(query) !== -1;
        var show = matchCat && matchSearch;
        card.classList.toggle('is-hidden', !show);
        if (show) visible++;
      });

      if (count) count.textContent = String(visible);
      if (empty) empty.classList.toggle('dgtl-hidden', visible > 0);
    }

    if (filter) filter.addEventListener('change', applyFilter);
    if (search) search.addEventListener('input', applyFilter);

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        currentCat = btn.getAttribute('data-filter') || 'all';
        filterBtns.forEach(function (b) {
          b.classList.toggle('is-active', (b.getAttribute('data-filter') || 'all') === currentCat);
        });
        applyFilter();
        if (hud) hud.rebuild();
      });
    });

    var clock = gallery.querySelector('[data-rlc-clock]');
    if (clock) {
      var tick = function () {
        var d = new Date();
        clock.textContent =
          String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
      };
      tick();
      setInterval(tick, 15000);
    }

    /* ---- HUD: shuffles through the archive on its own, muted ---- */
    var hud = (function () {
      var root = gallery.querySelector('[data-rlc-hud]');
      if (!root) return null;
      var screen = root.querySelector('[data-hud-screen]');
      var video = root.querySelector('[data-hud-video]');
      var toggleBtn = root.querySelector('[data-hud-toggle]');
      var toggleIco = root.querySelector('[data-hud-toggle-ico]');
      var metaEl = root.querySelector('[data-hud-meta]');
      var progressEl = root.querySelector('[data-hud-progress]');
      if (!video) return null;

      var queue = [];
      var position = -1;
      var paused = false;
      var current = null;

      function playableCards() {
        var out = [];
        gallery.querySelectorAll('[data-video-open]').forEach(function (btn) {
          var card = btn.closest('[data-video-card]');
          if (card && card.classList.contains('is-hidden')) return;
          var url = btn.getAttribute('data-video-url') || '';
          if (!url) return;
          if (!/\.(mp4|webm|mov)(\?|$)/i.test(url) && url.indexOf('cdn.shopify.com') === -1) return;
          out.push(btn);
        });
        return out;
      }

      function shuffle(list) {
        var arr = list.slice();
        for (var i = arr.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = arr[i];
          arr[i] = arr[j];
          arr[j] = tmp;
        }
        return arr;
      }

      function setIdle(message) {
        current = null;
        video.removeAttribute('src');
        video.load();
        if (screen) screen.classList.add('is-empty');
        if (metaEl) metaEl.textContent = message;
        if (progressEl) progressEl.style.width = '0';
        if (nowPlaying) nowPlaying.textContent = 'STANDBY';
      }

      function load(step) {
        if (!queue.length) {
          setIdle('NO PLAYABLE RELICS');
          return;
        }
        position += step;
        if (position >= queue.length) {
          queue = shuffle(queue);
          position = 0;
        }
        if (position < 0) position = queue.length - 1;

        current = queue[position];
        if (screen) screen.classList.remove('is-empty');
        video.src = current.getAttribute('data-video-url');
        if (metaEl) {
          metaEl.textContent =
            (current.getAttribute('data-category') || '') +
            ' / ' +
            (current.getAttribute('data-year') || '') +
            ' / SHUFFLE ' +
            String(position + 1) +
            ' OF ' +
            queue.length;
        }
        if (nowPlaying) nowPlaying.textContent = current.getAttribute('data-title') || 'STANDBY';
        if (progressEl) progressEl.style.width = '0';
        if (!paused) {
          var attempt = video.play();
          if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
        }
      }

      function rebuild() {
        queue = shuffle(playableCards());
        position = -1;
        load(1);
      }

      function setPaused(next) {
        paused = next;
        if (toggleIco) {
          toggleIco.className = 'rlc-ico ' + (paused ? 'rlc-ico--play' : 'rlc-ico--pause');
        }
        if (toggleBtn) {
          toggleBtn.setAttribute('aria-label', paused ? 'Resume shuffle' : 'Pause shuffle');
        }
        if (paused) {
          video.pause();
        } else if (current) {
          var attempt = video.play();
          if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
        }
      }

      video.addEventListener('ended', function () {
        load(1);
      });

      video.addEventListener('timeupdate', function () {
        if (!progressEl || !video.duration) return;
        progressEl.style.width = (video.currentTime / video.duration) * 100 + '%';
      });

      video.addEventListener('error', function () {
        if (queue.length > 1) load(1);
        else setIdle('RELIC UNAVAILABLE');
      });

      if (toggleBtn) {
        toggleBtn.addEventListener('click', function () {
          setPaused(!paused);
        });
      }

      var prevBtn = root.querySelector('[data-hud-prev]');
      if (prevBtn) prevBtn.addEventListener('click', function () { load(-1); });

      var nextBtn = root.querySelector('[data-hud-next]');
      if (nextBtn) nextBtn.addEventListener('click', function () { load(1); });

      if (screen) {
        screen.addEventListener('click', function () {
          if (current) current.click();
        });
      }

      return {
        rebuild: rebuild,
        suspend: function () { video.pause(); },
        resume: function () { if (!paused && current) { var a = video.play(); if (a && a.catch) a.catch(function () {}); } }
      };
    })();

    gallery.querySelectorAll('[data-video-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!lightbox || !player) return;
        var idx = btn.getAttribute('data-index');
        var title = btn.getAttribute('data-title');
        var category = btn.getAttribute('data-category');
        var year = btn.getAttribute('data-year');
        var url = btn.getAttribute('data-video-url');
        var idEl = lightbox.querySelector('[data-lightbox-id]');
        var titleEl = lightbox.querySelector('[data-lightbox-title]');
        var subEl = lightbox.querySelector('[data-lightbox-sub]');
        if (idEl) idEl.textContent = '[RELIC-' + String(idx).padStart(3, '0') + ']';
        if (titleEl) titleEl.textContent = title;
        if (subEl) subEl.textContent = category + ' | ' + year;
        player.innerHTML = embedVideoUrl(url);
        lightbox.classList.remove('dgtl-hidden');
        document.body.style.overflow = 'hidden';
        if (hud) hud.suspend();
        startRelicPlayback(player);
      });
    });

    function closeLightbox() {
      if (!lightbox || !player) return;
      exitDocumentFullscreen();
      lightbox.classList.add('dgtl-hidden');
      player.innerHTML = '';
      document.body.style.overflow = '';
      if (hud) hud.resume();
    }

    var closeBtn = gallery.querySelector('[data-video-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (lightbox) {
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox && !lightbox.classList.contains('dgtl-hidden')) closeLightbox();
    });

    applyFilter();
    if (hud) hud.rebuild();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initTimestamp();
    initOverlayTime();
    initProductGallery();
    initQuantity();
    initVariants();
    initRelicTheme();
    initVideoGallery();
  });
})();
